var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-checkbox',_vm._g(_vm._b({},'el-checkbox',_vm.$attrs,false),_vm.$listeners),[_vm._v(_vm._s(_vm.title))])
}
var staticRenderFns = []

export { render, staticRenderFns }